module.exports = __webpack_public_path__ + "img/train-1.6a08188d.jpg";